import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * Wrapper che protegge le route riservate agli utenti loggati.
 * Se non loggato, reindirizza a /login salvando "from" per eventuale redirect post-login.
 */
function RequireAuth({ userService, children }) {
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(null);

  useEffect(() => {
    if (!userService || typeof userService.isLoggedIn !== 'function') {
      setIsLoggedIn(false);
      return;
    }
    const subscription = userService.isLoggedIn().subscribe((logged) => {
      setIsLoggedIn(!!logged);
    });
    return () => subscription.unsubscribe();
  }, [userService]);

  if (isLoggedIn === null) {
    return null;
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

export default RequireAuth;
